import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-peer",
  "use": "icon-leo-e1-peer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-peer\">\r\n<g transform=\"translate(-61.440 -25.600) scale(1.120000)\">\r\n<path d=\"M128 256h320v448H128V256zm64 64v320h192V320H192z\" />\r\n  <path d=\"M576 256h320v448H576V256zm64 64v320h192V320H640z\" />\r\n  <path d=\"M416 448h192v64H416v-64z\" />\r\n  <path d=\"M480 352l96 128H416l64-128zm0 320l-64-128h160L480 672z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-peer.svg
// module id = cl/p
// module chunks = 546